import { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import gsap from 'gsap';

import { AeroportFontCont } from '../../fonts/AeroportFont_Cont';
import Burger from '../../components/Nav/Burger.jsx';
import CargaImagenes from './CargaImagenes';
import useMediaQuery from '../../hooks/MediaQueryhook';
import Spy from '../../Spy';
import { MargenesCards } from '../../VariablesGlobales.js';

// Import the raw data
import { img } from './photos';

const varMargenBig = MargenesCards('A');
const varMargenSmall = MargenesCards('B');

// --- Styled Components (Kept original styles) ---
const FirstFrame = styled.div`
  background-color: #ffffff;
`;

const ContainerNavBar = styled.div`
  display: grid;
  grid-template-rows: repeat(1, 1fr);
  position: fixed;
  justify-items: center;
  top: 0;
  right: 0;
  height: 5%;
  width: 50vw;
  justify-self: stretch;
  @media screen and (min-width: 0px) and (max-width: 480px) {
    width: 100vw;
    grid-template-columns: 1rem 1rem auto 1rem 80px;
  }
  @media screen and (min-width: 481px) and (max-width: 768px) {
    width: 100vw;
    grid-template-columns: 2.5rem 1vw auto 1vw 100px;
  }
  @media screen and (min-width: 769px) {
    grid-template-columns: 2.5vw 1vw auto 1vw 120px;
  }
`;

const ContainerService = styled.div`
  width: 100%;
  background-color: #ffffff;
  position: relative;
`;

const ConTxT = styled.div`
  z-index: 9;
  @media screen and (min-width: 0px) and (max-width: 768px) {
    padding-left: 5vw;
    padding-bottom: 5vw;
  }
  @media screen and (min-width: 769px) {
    padding-left: 2.5vw;
    padding-bottom: 2.5vw;
  }
`;

const ContTxtTitle = styled.div`
  a {
    margin-left: -0.04em;
  }
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;
  width: 100%;
`;

const ContImgGeneral = styled.div`
  display: block;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  background-color: #ffffff;
  overflow-x: hidden;

  /* 1. MOBILE (Full width stacked images - Tallest) */
  @media screen and (min-width: 0px) and (max-width: 768px) {
    padding-left: ${varMargenSmall};
    padding-right: calc(${varMargenSmall} + 15px);
    padding-bottom: calc(${varMargenSmall} * 2);
    min-height: 3500vw;
  }

  /* 2. TABLET (The New Tier) */
  @media screen and (min-width: 769px) and (max-width: 1024px) {
    padding-left: ${varMargenBig};
    padding-right: calc(${varMargenBig} + 15px);
    min-height: 940vw;
  }

  /* 3. DESKTOP (Wide screens - Shortest relative to width) */
  @media screen and (min-width: 1025px) {
    padding-left: ${varMargenBig};
    padding-right: calc(${varMargenBig} + 15px);
    padding-bottom: calc(${varMargenBig} * 2);
    min-height: 910vw;
  }
`;

const MaxCont = styled.div`
  background-color: #ffffff;
  display: block;
  width: 100%;
`;

const GalleryImages = () => {
  Spy('OpenPages', 'Catalog');

  var isMediaQuery769px = useMediaQuery('(max-width: 769px)');
  const ContTxtTitleRef = useRef(null);
  const cardAnimRef = useRef(null);
  const divAuxiliartoHeight = useRef(null);
  const [hValueAuxMarginFirstImg, setHValueAuxMarginFirstImg] = useState(0);

  // --- Filtering Removed ---
  // We now use the raw 'img' array directly
  const allImages = img;

  window.addEventListener(
    'resize',
    function () {
      if (isMediaQuery769px === true) {
        if (divAuxiliartoHeight.current) {
          setHValueAuxMarginFirstImg(divAuxiliartoHeight.current.clientHeight);
        }
      }
    },
    true
  );

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (cardAnimRef.current) {
        const targets = cardAnimRef.current.querySelectorAll('.zoom-target');

        targets.forEach((target) => {
          gsap.killTweensOf(target);
          const zoomTimeline = gsap.timeline({ paused: true });

          zoomTimeline.to(target, {
            scale: 1.03,
            duration: 0.5,
            ease: 'power1.out',
          });

          const trigger = target.parentElement;
          const playAnim = () => zoomTimeline.play();
          const reverseAnim = () => zoomTimeline.reverse();

          trigger.addEventListener('mouseenter', playAnim);
          trigger.addEventListener('mouseleave', reverseAnim);
        });
      }
    }, 400);

    return () => clearTimeout(timeout);
  }, []); // Run only on mount since images are now static

  useEffect(() => {
    const handleImageLoad = () => {
      if (divAuxiliartoHeight.current) {
        setHValueAuxMarginFirstImg(divAuxiliartoHeight.current.clientHeight);
      }
    };

    if (divAuxiliartoHeight.current) {
      divAuxiliartoHeight.current.addEventListener('load', handleImageLoad);
    }

    return () => {
      // Cleanup if necessary
    };
  }, []);

  return (
    <>
      <ContainerNavBar id="boton" style={{ zIndex: '15' }}>
        <Burger />
      </ContainerNavBar>

      <FirstFrame>
        <MaxCont>
          <ContainerService id="cServ">
            <ContTxtTitle ref={ContTxtTitleRef}>
              <ConTxT>
                <AeroportFontCont
                  sizePhone="55px"
                  sizeSmall="85px"
                  sizeMedium="55px"
                  sizeBig="110px"
                  lHeightDefault="1"
                  pTop="30px"
                >
                  <a>Our Catalog</a>
                </AeroportFontCont>

                <AeroportFontCont
                  sizePhone="16px"
                  sizeSmall="16px"
                  sizeMedium="12px"
                  sizeBig="16px"
                  lHeightPhone="1.5"
                  lHeightBig="1.6"
                >
                  <span
                    style={{
                      maxWidth: '400px',
                      marginTop: '5px',
                      paddingTop: '0px',
                      borderTop: '1px solid #000000',
                    }}
                  >
                    → A Selection Of Images, Sketches And Animations.
                  </span>
                </AeroportFontCont>
              </ConTxT>
            </ContTxtTitle>
          </ContainerService>

          {/* Auxiliary image for height calculation (uses first image in array) */}
          {allImages?.length > 0 && allImages[0]?.small && (
            <img
              ref={divAuxiliartoHeight}
              style={{
                zIndex: '-1',
                display: 'block',
                opacity: 0,
                position: 'absolute',
                top: 0,
                left: 0,
                width: 'calc(100% - 20px)',
                height: 'auto',
                margin: '10px',
              }}
              src={allImages[0].small}
              alt="Helper"
            />
          )}

          <ContImgGeneral ref={cardAnimRef}>
            <CargaImagenes images={allImages} />
          </ContImgGeneral>
        </MaxCont>
      </FirstFrame>
    </>
  );
};

export { GalleryImages };
